export const text = {
  STATE: 'State',
  DRUG_SCREENING: 'Drug screening',
  PHONE_VISITS: 'Phone visits',
} as const
